import React from 'react';
import TextField from "./TextField";
import {useApiIsLoaded, useMapsLibrary} from '@vis.gl/react-google-maps';
import {consoleWarn} from "../../utils/log";

const LocationAutocomplete = props => {
    const inputRef = React.useRef(null);
    const [service, setService] = React.useState(null);
    const isLoaded = useApiIsLoaded();
    const placesLib = useMapsLibrary('places');

    React.useEffect(() => {
        if (!placesLib || service) return;
        setService(new placesLib.PlacesService(null));
    }, [placesLib, service]);

    React.useEffect(() => {
        if (!isLoaded || !service || !inputRef.current) return;
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const {latitude, longitude} = position.coords;
                const center = {lat: latitude, lng: longitude};

                const defaultBounds = {
                    north: center.lat + 0.1,
                    south: center.lat - 0.1,
                    east: center.lng + 0.1,
                    west: center.lng - 0.1,
                };

                const options = {
                    bounds: defaultBounds,
                    fields: ['formatted_address', 'geometry'],
                    strictBounds: false,
                };

                if (inputRef.current) {
                    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, options);
                    autocomplete.addListener('place_changed', () => {
                        const place = autocomplete.getPlace();
                        if (place.formatted_address) {
                            props.onChange(place.formatted_address);
                        }
                    });
                }
            },
            (err) => consoleWarn('Geolocation error:', err?.code),
            {enableHighAccuracy: true}
        );
    }, [isLoaded, service, inputRef]); //eslint-disable-line

    return (
        <TextField
            {...props}
            onRef={r => (inputRef.current = r)}
            fullWidth
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder || ''}
        />
    );
}

export default LocationAutocomplete;